import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const quickActions = [
    {
      title: "Report Outage",
      description: "Report a new service outage",
      icon: "AlertTriangle",
      path: "/report-outage",
      variant: "default",
      color: "bg-primary text-primary-foreground"
    },
    {
      title: "View Map",
      description: "Geographic outage visualization",
      icon: "Map",
      path: "/geographic-outage-map",
      variant: "outline",
      color: "bg-card border-border"
    },
    {
      title: "Service Details",
      description: "Detailed outage information",
      icon: "FileText",
      path: "/service-outage-details",
      variant: "outline",
      color: "bg-card border-border"
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={20} className="text-foreground" />
        <h3 className="font-semibold text-foreground">Quick Actions</h3>
      </div>
      {/* Action Buttons */}
      <div className="space-y-3">
        {quickActions?.map((action) => (
          <Link key={action?.path} to={action?.path} className="block">
            <div className="flex items-center space-x-3 p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors duration-200 cursor-pointer">
              <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${action?.color}`}>
                <Icon 
                  name={action?.icon} 
                  size={20} 
                  className={action?.variant === 'default' ? 'text-primary-foreground' : 'text-primary'}
                />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-foreground">{action?.title}</h4>
                <p className="text-sm text-muted-foreground">{action?.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </div>
          </Link>
        ))}
      </div>
      {/* Additional Actions */}
      <div className="mt-4 pt-3 border-t border-border">
        <div className="grid grid-cols-2 gap-2">
          <Button variant="ghost" size="sm" className="justify-start">
            <Icon name="Search" size={16} className="mr-2" />
            Search Services
          </Button>
          <Button variant="ghost" size="sm" className="justify-start">
            <Icon name="Bell" size={16} className="mr-2" />
            Notifications
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;